import React from "react";
import mobaTrainerIcon from "./ads/mobatrainer_icon.png";
import { useSnapshot } from "valtio";
import { platformState } from "@shared/states/uiStates";
import { LinkoraLink, useLinkoraAd } from "@shared/Sidebar/AdView";

interface TopAdBannerProps {
	place: string;
}

const MobaTrainerAd: React.FC<{ link: LinkoraLink }> = (props) => {
	return (
		<a
			href={`https://link.duiker101.net/visit/${props.link.uuid}/`}
			target={"_blank"}
			rel={"noreferrer nofollow"}
		>
			<div
				className={
					"flex items-center rounded bg-slate-600 mb-2 p-2 gap-2 border border-slate-400 relative hover:brightness-125 cursor-pointer"
				}
			>
				<img src={mobaTrainerIcon} className={"h-12 w-auto rounded"} />
				<div className={"flex-1 text-white"}>
					<div className={"text-xl"}>MOBA Trainer</div>
					<div className={"opacity-50 text-sm"}>
						Improve your performance and win more games
					</div>
				</div>
				<div className={"absolute right-2 bottom-0 text-sm text-white"}>Ad</div>
			</div>
		</a>
	);
};

const WebTopBanner = () => {
	const link = useLinkoraAd("riftkit_sb_top");

	if (link?.text === "mobatrainer_top") {
		return <MobaTrainerAd link={link} />;
	}

	return null;
};

const TopAdBanner: React.FC<TopAdBannerProps> = (props) => {
	const platformSnap = useSnapshot(platformState);
	if (platformSnap.platform === "desktop") {
		return null;
	}

	return <WebTopBanner />;
};

export { TopAdBanner };
